import React from 'react';
import { Box, Text, VStack, HStack, Tooltip } from '@chakra-ui/react';
import { useIsMobile } from '../../../../helpers/useIsMobile';
import { trackingService } from '../../../../shared/eventTracking';

interface InstructionsCollapseProps {
  showInstructions: boolean;
  setShowInstructions: (show: boolean) => void;
}

const instructionsTexts = [
  '• <b>Medicamento:</b> <span style="font-weight: 600;">"Amoxicilina, 500mg, 1 cápsula, via oral, a cada 8h"</span>',
  '• <b>Exame:</b> <span style="font-weight: 600;">"Hemograma completo, indicado para investigação de anemia"</span>',
  '• <b>Encaminhamento:</b> <span style="font-weight: 600;">"Encaminhar o paciente para avaliação pós operatória com Cardiologista"</span>',
  '• <b>Atestado:</b> <span style="font-weight: 600;">"Atestado de 3 dias, para afastamento laboral, a contar da data de hoje"</span>',
  '• <b>Cuidados:</b> <span style="font-weight: 600;">"Fale claro, em locais sem ruído, sem abreviações ou regionalismos"</span>',
];

function InstructionsCollapse({ showInstructions, setShowInstructions }: InstructionsCollapseProps) {
  const isMobile = useIsMobile();

  const InstructionsContent = () => (
    <Box position={isMobile ? 'absolute' : 'relative'} zIndex={3}>
      {isMobile && (
        <Box
          position="absolute"
          top="-8px"
          left="50%"
          transform="translateX(-50%)"
          width="0"
          height="0"
          borderLeft="8px solid transparent"
          borderRight="8px solid transparent"
          borderBottom="8px solid"
          borderBottomColor="purple.800"
        />
      )}
      {!isMobile && (
        <Box
          position="absolute"
          top="16px"
          right="-8px"
          width="0"
          height="0"
          borderTop="8px solid transparent"
          borderBottom="8px solid transparent"
          borderLeft="8px solid"
          borderLeftColor="purple.800"
        />
      )}
      <Box bg="purple.800" borderRadius="12px" p="16px" pr={isMobile ? '40px' : '16px'}>
        <VStack align="flex-start" spacing="12px">
          {instructionsTexts.map((text, index) => (
            <Text
              key={index}
              fontSize="12px"
              color="white"
              lineHeight="1.6"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          ))}
        </VStack>
      </Box>
    </Box>
  );

  const TriggerBox = () => (
    <Box
      bg="pink.100"
      borderRadius="12px"
      p="12px"
      cursor="pointer"
      onClick={
        isMobile
          ? () => {
            trackingService.trackPrescriptionVoiceHintToggle();
            setShowInstructions(!showInstructions);
          }
          : undefined
      }
    >
      <HStack spacing="8px">
        <Text fontSize="16px">ⓘ</Text>
        <Text fontWeight="semibold" fontSize="14px" color="purple.600">
          Como ditar uma prescrição
        </Text>
      </HStack>
    </Box>
  );

  if (isMobile) {
    return (
      <Box px="16px" pt="16px" pb="16px">
        <VStack align="stretch" spacing="12px">
          <TriggerBox />
          {showInstructions && (
            <Box position="relative" mt="8px">
              <Box
                position="absolute"
                top="16px"
                right="16px"
                cursor="pointer"
                onClick={() => {
                  trackingService.trackPrescriptionVoiceHintToggle();
                  setShowInstructions(false);
                }}
                zIndex="2"
              >
                <Text fontSize="24px" fontWeight="bold" color="white" lineHeight="1">
                  ×
                </Text>
              </Box>
              <InstructionsContent />
            </Box>
          )}
        </VStack>
      </Box>
    );
  }

  return (
    <Box px="16px" pt="16px" pb="16px">
      <Tooltip label={<InstructionsContent />} placement="left-start" bg="transparent" p="0" borderRadius="12px">
        <Box onMouseEnter={() => trackingService.trackPrescriptionVoiceHintToggle()}>
          <TriggerBox />
        </Box>
      </Tooltip>
    </Box>
  );
}

export { InstructionsCollapse };
